import { JudgeStatePresenter } from '@/presentation/presenters/judge/judgeStatePresenter'
import { JudgeStateViewModel } from '@/presentation/viewmodels/judge/judgeStateViewModel'

export function useJudgeStatePresenter(
  presenter: JudgeStatePresenter = new JudgeStatePresenter(new JudgeStateViewModel())
) {
  return {
    judgeId: presenter.judgeId,
    isTestLoading: presenter.isTestLoading,
    isJudgeLoading: presenter.isJudgeLoading,
    isTestNotificationLoading: presenter.isTestNotificationLoading,
    isJudgeNotificationLoading: presenter.isJudgeNotificationLoading,
    judgeRecord: presenter.judgeRecord,
    testInput: presenter.testInput,
    testOutput: presenter.testOutput,
    setTestInput: presenter.setTestInput.bind(presenter),
    setTestOutput: presenter.setTestOutput.bind(presenter)
  }
}
